import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import handleAsyncThunk from "../handleAsyncThunk";
import { showErrorSnackbar } from "./snackbarSlice";
import seasonApi from "../../services/seasonApi";

export const getCurrentSeasons = createAsyncThunk('season/getCurrentSeasons', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await seasonApi.getCurrentSeasons({});
        if (response.status === 0) {
            if(response?.data?.seasons?.length > 0){
                if(data && data?.seasonId) {
                    const season = response?.data?.seasons.find(season => season?._id === data?.seasonId);
                    dispatch(setCurrentSeason(season))
                }else {
                    dispatch(setCurrentSeason(response?.data?.seasons[0]))
                }
                dispatch(setSeasonsFetched())
            }else {
                dispatch(setCurrentSeason(null))
            }

            return response?.data?.seasons; // Return the response data on success
        } else {
            // show error toast message
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
})

// get current season details
export const getSeasonDetails = createAsyncThunk('season/getSeasonDetails', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await seasonApi.getSeasonDetails(data);
        if (response.status === 0) {
            if(response?.data?.seasonDetails){
                dispatch(setCurrentSeason(response?.data?.seasonDetails))
            }else {
                dispatch(setCurrentSeason(null))
            }
            
            return response?.data?.seasonDetails; // Return the response data on success
        } else {
            // show error toast message
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
})

const seasonSlice = createSlice({
    name: 'season',
    initialState: {
        isLoading: false,
        fetchingSeasons: false,
        fetchingSport: false,
        seasons: [],
        seasonData: null,
        index: -1,
        currentSeason: null,
        fetchedSeasons: false,
        error: null
    },
    reducers: {
        setCurrentSeason: (state, action) => {
            state.currentSeason = action.payload;
            state.index = action.payload ? state.seasons.findIndex(season => season?._id === state.currentSeason?._id) : -1;
        },
        setCurrentSeasonById: (state, action) => {
            const seasonId = action.payload;

            const seasonInd = state.seasons.findIndex(season => season?._id === seasonId);
            if(seasonInd > -1) {
                state.currentSeason = state.seasons[seasonInd];
                state.index = seasonId;
            }
        },
        getAllSeasons: (state) => {
            return state.fetchedSeasons;
        },
        setSeasonsFetched: (state) => {
            state.fetchedSeasons = true;
        }
    },
    extraReducers: (builder) => {
        handleAsyncThunk(builder, getCurrentSeasons, 'seasons', "", "fetchingSeasons")
        handleAsyncThunk(builder, getSeasonDetails, 'seasonData', "", "fetchingSport")
    }
})

export const { setCurrentSeason, setSeasonsFetched, setCurrentSeasonById, getAllSeasons } = seasonSlice.actions

export default seasonSlice.reducer